import { render } from "./quantityCounter.vue?vue&type=template&id=10d3d796"
import script from "./quantityCounter.vue?vue&type=script&lang=js"
export * from "./quantityCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__